import React, { Component } from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import Setup_done from './Setup_Done';
import Price_request_pop from './Price_request_pop';
import Price_setup_pop from './Price_setup_pop';
import { userService } from "../../_services";

/**
 * Pricing Tool Component
 * Modernized with Shadcn Card and Button components
 */
class Pricing_tool extends Component {
    constructor(props) {
        super(props);
        let Usermeta_Data = '';
        let PTRequest = '';
        let _groupnumber_ = ''; 
        let _subdomain_ = '';
        let IsApproved = false;
        
        if (this.props.profileData.length > 0) {
            PTRequest = this.props.profileData[0]["pricingToolRequestStatus"];
            IsApproved = this.props.profileData[0]["adminApproval"];
            _groupnumber_ = this.props.profileData[0]["groupNumber"];
            _subdomain_ = this.props.profileData[0]["subDomain"];
        }
        
        try {
            Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        } catch (error) {
            console.error('Error getting user data:', error);
        }
        
        this.state = {
            request_box: false,
            request_granted: false,
            setup_model: false,
            setup_success: false,
            PricingToolStatus: [],
            UserData: Usermeta_Data,
            PricingToolRequestStatus: PTRequest,
            adminRequestforTool: IsApproved,
            groupNumber: _groupnumber_,
            subDomain: _subdomain_
        };
        
        this.toogle_request_pop = this.toogle_request_pop.bind(this);
        this.toggle_setup_model = this.toggle_setup_model.bind(this);
        this.submit_setup = this.submit_setup.bind(this);
    }
    
    componentDidMount() {
        try {
            localStorage.setItem('subDomain', this.state.subDomain);
        } catch (error) {
            console.error('Error setting subDomain:', error);
        }
    }
    
    toogle_request_pop = e => {
        e.stopPropagation();
        this.setState({ request_box: !this.state.request_box });
    }
    
    submitRequest = (e) => {
        try {
            this.GetPricingToolUpdate(this.state.UserData.split(':')[0], '', '', 'Request');
        } catch (error) {
            console.error('Error submitting request:', error);
        }
        this.setState({ request_box: false, request_granted: true });
    }
    
    toggle_setup_model = e => {
        e.stopPropagation();
        this.setState({ setup_model: !this.state.setup_model });
    }
    
    submit_setup = (_subDomain, _groupNumber, _actionType) => {
        this.setState({ 
            setup_success: true, 
            setup_model: false, 
            groupNumber: _groupNumber, 
            subDomain: _subDomain, 
            PricingToolRequestStatus: _actionType 
        });
        this.props.getPricing();
        this.toggle_setup_model();
    }

    GetPricingToolUpdate(UserId, SubDomain, GroupNumber, Task_Name) {
        try {
            userService.PricingToolInitialStatus(UserId, SubDomain, GroupNumber, Task_Name)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ PricingToolRequestStatus: apidata[0].requestStatus });
                        }
                        this.setState({ PricingToolStatus: apidata });
                    } catch (error) {
                        console.error('Error processing pricing tool data:', error);
                    }
                });
        } catch (error) {
            console.error('Error getting pricing tool update:', error);
        }
    }

    render() {
        let showemail = userService.getemail();
        const tooltipText = "Integrate the pricing tool you see on our homepage into your own website. This will be linked to your unique group number.";
        
        return (
            <Card>
                <CardContent className="p-6">
                    {/* Rejected Status */}
                    {this.props.profileData[0].pricingToolRequestStatus === "Rejected" && (
                        <div className="space-y-3">
                            <div className="flex items-center gap-2">
                                <h3 className="text-lg font-semibold text-foreground">Pricing Tool</h3>
                            </div>
                            <div className="p-4 bg-red-50 border border-red-200 rounded-md">
                                <p className="text-sm text-red-800">
                                    Your request has been rejected. Please{' '}
                                    <a href={"mailto:" + showemail} className="text-brand-accent hover:underline font-medium">
                                        contact us
                                    </a>
                                    {' '}for more details
                                </p>
                            </div>
                        </div>
                    )}
                    
                    {/* Requested Status */}
                    {this.props.profileData[0].pricingToolRequestStatus === "Requested" && (
                        <div className="space-y-4">
                            <div className="flex items-center gap-2">
                                <h3 className="text-lg font-semibold text-foreground">Pricing Tool</h3>
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>
                                            <button type="button" className="text-muted-foreground hover:text-foreground">
                                                <InfoIcon className="h-4 w-4" />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent className="max-w-xs">
                                            <p className="text-sm">{tooltipText}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                            <div className="flex flex-wrap gap-3">
                                {userService.Check_Null_Empty(this.state.PricingToolRequestStatus) ? (
                                    <Button 
                                        variant="outline" 
                                        onClick={this.toogle_request_pop}
                                    >
                                        Click to Request Pricing Tool
                                    </Button>
                                ) : !this.state.adminRequestforTool ? (
                                    <div className="px-4 py-2 bg-yellow-50 text-yellow-800 rounded-md text-sm font-medium">
                                        Pending
                                    </div>
                                ) : null}
                                <Button 
                                    variant="secondary"
                                    onClick={this.toggle_setup_model}
                                    disabled={!this.state.adminRequestforTool}
                                >
                                    Click to Setup
                                </Button>
                            </div>
                        </div>
                    )}
                    
                    {/* Empty Status (No Request) */}
                    {this.props.profileData[0].pricingToolRequestStatus === "" && (
                        <div className="space-y-4">
                            <div className="flex items-center gap-2">
                                <h3 className="text-lg font-semibold text-foreground">Pricing Tool</h3>
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>
                                            <button type="button" className="text-muted-foreground hover:text-foreground">
                                                <InfoIcon className="h-4 w-4" />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent className="max-w-xs">
                                            <p className="text-sm">{tooltipText}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                            <div className="flex flex-wrap gap-3">
                                {userService.Check_Null_Empty(this.state.PricingToolRequestStatus) ? (
                                    <Button 
                                        variant="outline" 
                                        onClick={this.toogle_request_pop}
                                    >
                                        Click to Request Pricing Tool
                                    </Button>
                                ) : !this.state.adminRequestforTool ? (
                                    <div className="px-4 py-2 bg-yellow-50 text-yellow-800 rounded-md text-sm font-medium">
                                        Pending
                                    </div>
                                ) : null}
                                <Button 
                                    variant="secondary"
                                    onClick={this.toggle_setup_model}
                                    disabled={!this.state.adminRequestforTool}
                                >
                                    Click to Setup
                                </Button>
                            </div>
                        </div>
                    )}
                    
                    {/* Approved but Not Setup */}
                    {((this.props.profileData[0].pricingToolRequestStatus === "Approved" && this.props.profileData[0].subDomain === "") || 
                      (this.props.profileData[0].pricingToolRequestStatus === "Submitted" && this.props.profileData[0].isActive === false)) && (
                        <div className="space-y-4">
                            <div className="flex items-center gap-2">
                                <h3 className="text-lg font-semibold text-foreground">Pricing Tool</h3>
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>
                                            <button type="button" className="text-muted-foreground hover:text-foreground">
                                                <InfoIcon className="h-4 w-4" />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent className="max-w-xs">
                                            <p className="text-sm">{tooltipText}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            </div>
                            <Button 
                                variant="secondary"
                                onClick={this.toggle_setup_model}
                                disabled={!this.state.adminRequestforTool}
                            >
                                Click to Setup
                            </Button>
                        </div>
                    )}
                    
                    {/* Setup Complete */}
                    {this.props.profileData[0].pricingToolRequestStatus === "Submitted" && 
                     this.props.profileData[0].subDomain !== "" && 
                     this.props.profileData[0].isActive === true && (
                        <Setup_done 
                            groupNumber={this.state.groupNumber} 
                            subDomain={this.props.profileData[0].subDomain} 
                        />
                    )}
                    
                    {/* Modals */}
                    {this.state.request_box && (
                        <Price_request_pop 
                            CloseRequestPopUp={this.toogle_request_pop} 
                            submit_Request={this.submitRequest} 
                        />
                    )}
                    
                    {this.state.setup_model && (
                        <Price_setup_pop 
                            submit_Setup_Detail={this.submit_setup} 
                            close_setup={this.toggle_setup_model} 
                            titleText="Setup Pricing Tool" 
                            detailText="Setup or edit your unique web and mobile app pricing tool link by selecting the group number to use below"
                            popupName="createPricingTool" 
                            btnText="Create" 
                        />
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default Pricing_tool;
